export default "__VITE_ASSET__DybxwKDZ__"